import { render, staticRenderFns } from "./MeAvatar.vue?vue&type=template&id=2fa96703&scoped=true&lang=pug"
import script from "./MeAvatar.vue?vue&type=script&lang=js"
export * from "./MeAvatar.vue?vue&type=script&lang=js"
import style0 from "./MeAvatar.vue?vue&type=style&index=0&id=2fa96703&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa96703",
  null
  
)

export default component.exports